import * as Yup from "yup";

export const add_Expense_Boolean = (val: boolean) => ({
  name: val,
  fleet: val,
  branch: val,
  general: val,
  variance: val,
  sub: val,
  duration: val,
  company: val,
  category: val,
});
export const add_Fixed_Expense_Boolean = (val: boolean) => ({
  entity: val,
  entity_id: val,
  ref: val,
  duration: val,
  amt: val,
  company: val,
  salary_days: val,
  extra_salary_days: val,
});

export const add_Expense_Validation = Yup.object().shape({
  name: Yup.string().required("This is a required field"),
  sub: Yup.string().required("This is a required field"),
  category: Yup.object(),
  fleet: Yup.string(),
  branch: Yup.string(),
  general: Yup.string(),
  duration: Yup.string(),
  company: Yup.string(),
  monthly_duration: Yup.bool(),
});
export const add_Fixed_Expense_Validation = Yup.object().shape({
  entity_id: Yup.object().shape({
    value: Yup.string().required("This is a required field"),
  }),
  ref: Yup.object().shape({
    value: Yup.string().required("This is a required field"),
  }),
  duration: Yup.string().required("This is a required field"),
  amt: Yup.string().required("This is a required field"),
});

export const add_Sub_Income_Validation = Yup.object().shape({
  name: Yup.string().required("This is a required field"),
  ref: Yup.string().required("This is a required field"),
});
export const add_Sub_Income_Boolean = (val: boolean) => ({
  name: val,
  ref: val,
});
export const validateExpense = (schema: any, obj: any) => {
  try {
    if (!schema) return false;
    schema.validateSync(obj);
    return false;
  } catch (err: any) {
    return err.message;
  }
};

export const sanitizeDocument = (document: any) => {
  if (!document) return document; // Handle null/undefined case

  let sanitizedDocument = { ...document };

  if (document?.image === "") {
    sanitizedDocument.image = undefined; // Remove only if it's an empty string
  }

  if (document?.identifier === "" || document?.identifier === null) {
    sanitizedDocument.identifier = undefined; // Remove only identifier if needed
  }

  return sanitizedDocument;
};
